import classNames from "classnames"
import React from "react"
import {
  CalendarEventAvailabilitySlot,
  CalendarEventDataFragment,
  EventRegistration,
  EventRegistrationErrorType,
} from "../../../../../api/backend/backend-api"
import CustomPane from "../../../../../ui/molecules/CustomPane"
import { CalendarDate } from "../../../../../ui/organisms/CustomCalendar/types"
import EventCalendarForm from "../EventCalendarForm"
import EventCalendarInfo from "../EventCalendarInfo"
import EventCalendarSelect from "../EventCalendarSelect"
import EventCalendarTyp from "../EventCalendarTyp"
import classes from "./EventCalendarControl.module.css"

interface Props {
  calendar: CalendarEventDataFragment
  selectedDate?: CalendarDate
  onSelectedDateChange: (value: CalendarDate) => void
  selectedSlot?: CalendarEventAvailabilitySlot
  slotConfirmed?: boolean
  onSelectedSlotChange: (value: CalendarEventAvailabilitySlot) => void
  onSlotConfirm: (value: CalendarEventAvailabilitySlot) => void
  onSubmit: (data: any) => void
  submitting: boolean
  submitCompleted: boolean
  submitError: boolean
  submitErrorType?: EventRegistrationErrorType
  confirmedEvent?: EventRegistration
}

const EventCalendarControl = ({
  calendar,
  selectedDate,
  onSelectedDateChange,
  selectedSlot,
  slotConfirmed,
  onSelectedSlotChange,
  onSlotConfirm,
  onSubmit,
  submitCompleted,
  submitError,
  submitErrorType,
  submitting,
  confirmedEvent,
}: Props) => {
  return (
    <CustomPane
      className={classNames(classes.pane, {
        [classes.paneSmall]:
          !selectedDate || calendar.definition.options?.preSelection?.fixed,
      })}
      contents={[
        {
          content: (
            <div className={classes.info}>
              <EventCalendarInfo calendar={calendar} />
            </div>
          ),
        },
        {
          content: (
            <div className={classes.dates}>
              {!slotConfirmed ? (
                <EventCalendarSelect
                  calendar={calendar}
                  selectedDate={selectedDate}
                  onSelectedDateChange={onSelectedDateChange}
                  onSelectedSlotChange={onSelectedSlotChange}
                  onSlotConfirm={onSlotConfirm}
                  selectedSlot={selectedSlot}
                />
              ) : submitCompleted && confirmedEvent ? (
                <EventCalendarTyp calendar={calendar} data={confirmedEvent} />
              ) : (
                <EventCalendarForm
                  calendar={calendar}
                  onSubmit={onSubmit}
                  submitting={submitting}
                  submitError={submitError}
                  submitErrorType={submitErrorType}
                />
              )}
            </div>
          ),
          style: {
            flexBasis: selectedDate ? "33%" : undefined,
          },
        },
      ]}
    />
  )
}

export default EventCalendarControl
